import { render, staticRenderFns } from "./page015.vue?vue&type=template&id=0bf176ec&scoped=true&"
import script from "./page015.vue?vue&type=script&lang=js&"
export * from "./page015.vue?vue&type=script&lang=js&"
import style0 from "./page015.vue?vue&type=style&index=0&id=0bf176ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf176ec",
  null
  
)

export default component.exports